import { Paper, styled, Typography } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

const backgroundColor = theme.palette.primary.main;
const textColor = theme.palette.white;

export const StyledPaper = styled(Paper)`
  background: ${backgroundColor};
  border-radius: ${theme.radius.md};
  color: ${textColor};
`;

export const Header = styled(Typography)`
  font-weight: bold;
`;

export const Code = styled(Typography)`
  margin: 0.5rem 0;
`;
